import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ApiError, ErrorCode, RequestState } from 'shared/api';

import { updateJobPreferences } from '../api';
import { UpdateJobPreferencesPayload } from '../types';

interface JobPreferencesState {
    updateState: RequestState;
}

const initialState: JobPreferencesState = {
    updateState: {
        status: 'idle'
    }
};

const jobPreferencesSlice = createSlice({
    name: 'jobPreferences',
    initialState,
    reducers: {
        resetState: () => initialState
    },
    extraReducers: (builder) => {
        builder.addCase(updateJobPreferencesThunk.pending, (state) => {
            state.updateState = { status: 'pending' };
        });

        builder.addCase(updateJobPreferencesThunk.fulfilled, (state) => {
            state.updateState = { status: 'success' };
        });

        builder.addCase(updateJobPreferencesThunk.rejected, (state, { payload }) => {
            state.updateState = { status: 'error', errorCode: payload };
        });
    }
});

export const {
    resetState
} = jobPreferencesSlice.actions;

export default jobPreferencesSlice.reducer;

export const updateJobPreferencesThunk = createAsyncThunk<
void,
UpdateJobPreferencesPayload,
{ rejectValue: ErrorCode }
>(
    `${ jobPreferencesSlice.name }/update`,
    async (text, thunkAPI) => {
        const response = await updateJobPreferences(text);

        if (response instanceof ApiError) {
            return thunkAPI.rejectWithValue(response.errorCode);
        }
    }
);
